// src/utilities/restApi/report/prsstatus.ts
import { AxiosError } from 'axios';
import { restApi } from 'src/utilities/restApi';
import { ErrorResponse, SuccessResponse } from 'src/utilities/restApi/common/types/responses';
import { ResponsePostReportPrsStatusJob } from 'src/utilities/restApi/kanri/types/reportPrsStatus';
import { getCommonHeaders } from 'src/utilities/restApi/utilities/getCommonHeader';

// レポート作成の開始（ジョブの追加）
export const postReportPrsStatusJob = async () => {
  const config = { headers: await getCommonHeaders() };

  return new Promise<SuccessResponse<ResponsePostReportPrsStatusJob>>((resolve, reject) => {
    restApi()
      .post<SuccessResponse<ResponsePostReportPrsStatusJob>>('/report/prsstatus/job', {}, config)
      .then((response) => {
        resolve(response.data!)
      })
      .catch((error: AxiosError<ErrorResponse>) => {
        reject(error.response?.data)
      });
  });
};
